import * as path from "node:path";
import * as rc9 from "rc9";
import * as z from "zod";
import { decode } from "./decode.js";
const PRISMICRC = ".prismicrc";
const PrismicrcSchema = z.object({
  telemetry: z.boolean().optional()
});
const readRawPrismicrc = (dir) => {
  const rawPrismicrc = dir ? rc9.read({ dir, name: PRISMICRC }) : rc9.readUser(PRISMICRC);
  const { value: prismicrc, error } = decode(PrismicrcSchema, rawPrismicrc);
  if (error) {
    throw new Error(`Failed to parse ${dir ? path.resolve(dir, PRISMICRC) : `~/${PRISMICRC}`}: ${error.errors.join(", ")}`);
  }
  return prismicrc;
};
const readPrismicrc = (dir) => {
  const userPrismicrc = readRawPrismicrc();
  const projectPrismicrc = readRawPrismicrc(dir);
  return {
    ...userPrismicrc,
    ...projectPrismicrc
  };
};
export {
  readPrismicrc,
  readRawPrismicrc
};
//# sourceMappingURL=prismicrc.js.map
